import { Alert, Checkbox, FormControlLabel, Grid, Paper, styled } from '@mui/material';
import { Box } from '@mui/system';
import React, { Component } from 'react';
import Constantes from '../php/Constantes';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    }));

let desc = '';
let lugarCentral = '';
let vinculacion = '';
let cargo = '';
let grado = '';
let escalafon = '';
let codRelLab = '';
let codForPago = '';
let serieConcurso = '';

class IngresoFuncionarios extends Component {

    constructor(props){
        super(props);
        this.state = {

            //informacion del funcionario
            ingresoFuncionario: {
                //Datos personales
                pNombre: '',
                sNombre: '',
                pApellido: '',
                sApellido: '',
                ci: '',
                fechNacimiento: '',
                credencialSerie: '',
                credencialNumero: '',
                direccionCalle: '',
                direccionNumero: '',
                direccionLocalidad: '',
                direccionDepartamento: '',
                telefono: '',
                celular: '',
                carneSalud: '',
                sexo: '',
                ingresoInstitucion: '',
                idUsuario: '',

                //Formacion academica
                tituloUniversitario1: '',
                fechaExpedidoTitulo1: '',
                maestria1: '',
                fechaExpedidaMaestria1: '',
                postgrado1: '',
                fechaExpedidoPostgrado1: '',
                tituloUniversitario2: '',
                fechaExpedidoTitulo2: '',
                maestria2: '',
                fechaExpedidaMaestria2: '',
                postgrado2: '',
                fechaExpedidoPostgrado2: '',
                tituloUniversitario3: '',
                fechaExpedidoTitulo3: '',
                maestria3: '',
                fechaExpedidaMaestria3: '',
                postgrado3: '',
                fechaExpedidoPostgrado3: '',
                idForAcademica: '',

                //Datos Funcionario
                numeroFuncionario: '',
                cargo: '',
                escalafon: '',
                grado: '',
                serie: '',
                cargaHorariaHoras: '',
                cargaHorariaMinutos: '',
                horarioSalida: '',
                horaEntrada: '',
                lugar: '',
                lugarCentral: '',
                vinculacion: '',
                antiguedad: '0',
                diasLicencia: '0',
                codigoRelacionLaboral: '',
                codigoIngreso: '',
                puntajeConcurso: '',
                lugarOrdenamiento: '',
                codigoFormaPago: '',
                idFuncionario: '',
                activo: true,
                sueldoBase: '',
                subroga: '',
                gradoSubrogacion: '',
                escalafonSubrogacion: '',
                cargaHorariaHoraSubrogacion: '',
                cargaHorariaMinutosSubrogacion: '',
                desdeSubrogacion: '',
                hastaSubrogacion: '',
                conFormacion: false,
                regimenMedicos: '',

                modificarUsu: false,
            },

            //De base de datos
            codRelaLaboral: [],
            vinculacion: [],
            codFormaPago: [],
            lugaresTrabajo: [],
            serieBase: [],
            departamentos: [],
            datosObtenidos: {},
            horasEntrada: [],
            horasSalida: [],
            escalafones: [],
            ubicacionesCentral: [],
            cargos: [],
            codigosIngresos: [],

            //Errores
            errores: null,
            notificaciones: null,

            modificar: false,
            baja: false,
            realizoConsulta: false,
        };

        //Seteo los this en está parte
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioFormulario = this.manejarEnvioFormulario.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.actualizarDatos = this.actualizarDatos.bind(this);
        this.darDeBaja = this.darDeBaja.bind(this);
        this.activarFuncionario = this.activarFuncionario.bind(this);
        this.manejarCambiosDatosFormacion = this.manejarCambiosDatosFormacion.bind(this);
    }

    //Consulto la base de datos
    async componentDidMount(){

        const respuestaIngresos = await fetch(`${Constantes.RUTA_API}/obtener_codigosIngresos.php`);
        const datosIngresos = await respuestaIngresos.json();
        this.setState({
            codigosIngresos: datosIngresos,
        });

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_codigosRelLab.php`);
        const datos = await respuesta.json();
        this.setState({
            codRelaLaboral: datos,
        });

        const vin = await fetch(`${Constantes.RUTA_API}/obtener_vinculaciones.php`);
        const dat = await vin.json();
        this.setState({
            vinculacion: dat,
        });

        const pago = await fetch(`${Constantes.RUTA_API}/obtener_formasPago.php`);
        const datPago = await pago.json();
        this.setState({
            codFormaPago: datPago,
        });

        const datosCargos = await fetch(`${Constantes.RUTA_API}/obtener_cargos.php`);
        const datoCargo = await datosCargos.json();
        this.setState({
            cargos: datoCargo,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTrabajo: datoLugar,
        });

        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });

        const departamento = await fetch(`${Constantes.RUTA_API}/obtener_departamentos.php`);
        const datoDepartamento = await departamento.json();
        this.setState({
            departamentos: datoDepartamento,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntrada: datosEntrada,
        });

        const sal = await fetch(`${Constantes.RUTA_API}/obtener_salidas.php`);
        const datosSalida = await sal.json();
        this.setState({
            horasSalida: datosSalida,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });
    }

    render(){
        return (
            <div>
                {this.state.ingresoFuncionario.activo ? '' : <Alert severity='error' variant='filled' style={{width: "50%", marginLeft: "15rem"}}>FUNCIONARIO INACTIVO</Alert> }
                <form className='formulario'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                    <h3>Ingreso de Funcionarios</h3>
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    <Box sx={{ flexGrow: 1}}>
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={2.1}>
                                Número de Funcionario <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                            </Grid>
                            <Grid item xs={3}>
                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.ingresoFuncionario.numeroFuncionario} onChange={this.manejarCambiosDatos} type="text" />
                            </Grid>
                            <Grid item xs={1}>
                                <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                            </Grid>
                        </Grid>
                    </Box>
                </form>
                <form className='formulario' onSubmit={this.manejarEnvioFormulario}>
                    {this.state.realizoConsulta
                    ?
                        <fieldset>
                            <legend>DATOS PERSONALES</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.1}>
                                        Primer Nombre <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input label="sddddd" style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='pNombre' value={this.state.ingresoFuncionario.pNombre} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Segundo Nombre
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='sNombre' value={this.state.ingresoFuncionario.sNombre} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Primer Apellido <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='pApellido' value={this.state.ingresoFuncionario.pApellido} onChange={this.manejarCambiosDatos} />
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Segundo Apellido
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='sApellido' value={this.state.ingresoFuncionario.sApellido} onChange={this.manejarCambiosDatos} />
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        C.I. (SIN PUNTOS NI GUIONES) <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='ci' value={this.state.ingresoFuncionario.ci} onChange={this.manejarCambiosDatos} />
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Fecha Nacimiento <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='fechNacimiento' value={this.state.ingresoFuncionario.fechNacimiento} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Credencial <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "40%", float: 'left'}} id='credencialSerie' type="text" placeholder='SERIE' value={this.state.ingresoFuncionario.credencialSerie} onChange={this.manejarCambiosDatos}/><input style={{border: "2px solid #D6EAF8", width: "60%"}} type="number" placeholder='NUMERO' id='credencialNumero' value={this.state.ingresoFuncionario.credencialNumero} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={6.9}>
                                        {/*Estolo pongo para un salto de linea */}
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Direccion <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={8.1}>
                                        <input style={{border: "2px solid #D6EAF8", width: "40%", float: 'left'}} type="text" id='direccionCalle' placeholder='CALLE' value={this.state.ingresoFuncionario.direccionCalle} onChange={this.manejarCambiosDatos}/>
                                        <input style={{border: "2px solid #D6EAF8", width: "20%", float: 'left'}} type="number" id='direccionNumero' placeholder='NUMERO' value={this.state.ingresoFuncionario.direccionNumero} onChange={this.manejarCambiosDatos}/>
                                        <input style={{border: "2px solid #D6EAF8", width: "20%", float: 'left'}} type="text" id='direccionLocalidad' placeholder='LOCALIDAD' value={this.state.ingresoFuncionario.direccionLocalidad} onChange={this.manejarCambiosDatos}/>
                                        <select style={{width:"20%", border:"2px solid #D6EAF8"}} id='direccionDepartamento' value={this.state.ingresoFuncionario.direccionDepartamento} onChange={this.manejarCambiosDatos} >
                                                <option value=''>DEPARTAMENTOS</option>
                                                {this.state.departamentos.map((name) =>
                                                    <option
                                                    key={name.idDepartamentos}
                                                    value={name.idDepartamentos}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        {/*<input style={{border: "2px solid #D6EAF8", width: "20%"}} type="text" placeholder='DEPARTAMENTO' value={this.state.ingresoFuncionario.direccionDepartamento} onChange={this.manejarCambiosDatos}/>*/}
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Teléfono
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='telefono' value={this.state.ingresoFuncionario.telefono} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Celular <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='celular' value={this.state.ingresoFuncionario.celular} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.206}>
                                        Carné De Salud <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='carneSalud' value={this.state.ingresoFuncionario.carneSalud} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Sexo <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='sexo' value={this.state.ingresoFuncionario.sexo} onChange={this.manejarCambiosDatos}>
                                            <option value={''}>SEXO</option>
                                            <option value={0}>MASCULINO</option>
                                            <option value={1}>FEMENINO</option>
                                        </select>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Ingreso a Institución <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='ingresoInstitucion' value={this.state.ingresoFuncionario.ingresoInstitucion} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Mecanismo de Ingreso <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoIngreso' value={this.state.ingresoFuncionario.codigoIngreso} onChange={this.manejarCambiosDatos}>
                                            <option value={''}></option>
                                            {this.state.codigosIngresos.map((name) =>
                                            <option
                                            key={name.idCodigoIngreso}
                                            value={name.idCodigoIngreso}
                                            >{name.descripcion}</option>
                                            )}
                                        </select>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Puntaje <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {["0", "1", "2", "3", "4", "5"].includes(String(this.state.ingresoFuncionario.codigoIngreso))
                                    ?
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='puntajeConcurso' value={this.state.ingresoFuncionario.puntajeConcurso} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                    :
                                        <Grid item xs={3}>

                                        </Grid>
                                    }
                                    <Grid item xs={2.1}>
                                        Lugar Ordenamiento <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {["0", "1", "2", "3", "4", "5"].includes(String(this.state.ingresoFuncionario.codigoIngreso))
                                    ?
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='lugarOrdenamiento' value={this.state.ingresoFuncionario.lugarOrdenamiento} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                        </Grid>
                                    }
                                    <Grid item xs={2.1}>
                                        Vinculación <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <select disabled={this.state.modificar} style={{width:"100%", border:"2px solid #D6EAF8"}} id='vinculacion' value={this.state.ingresoFuncionario.vinculacion} onChange={this.manejarCambiosDatos} >
                                            <option value={''}>VINCULACION</option>
                                            {this.state.vinculacion.map((name) =>
                                                <option
                                                key={name.idVinculacion}
                                                value={name.idVinculacion}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                    {/*<Grid item xs={3}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='vinculacion' value={this.state.ingresoFuncionario.vinculacion} onChange={this.manejarCambiosDatos} >
                                            <option value={''}>VINCULACION</option>
                                            {this.state.vinculacion.map((name) =>
                                                <option
                                                key={name.idVinculacion}
                                                value={name.idVinculacion}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>*/}
                                    <Grid item xs={2.1}>
                                        Antigüedad
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='antiguedad' value={this.state.ingresoFuncionario.antiguedad} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    {/*<Grid item xs={2.1}>
                                        <Item>Días de Licencias</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='diasLicencia' value={this.state.ingresoFuncionario.diasLicencia} onChange={this.manejarCambiosDatos}/></Item>
                                    </Grid>*/}
                                </Grid>
                            </Box>
                        </fieldset>
                    :
                        null
                    }
                    {this.state.realizoConsulta
                    ?
                        <fieldset>
                            <legend>FORMACION ACADEMICA</legend>
                            <FormControlLabel label='Tiene Formación' control={<Checkbox checked={this.state.ingresoFuncionario.conFormacion} onChange={this.manejarCambiosDatosFormacion} id='conFormacion' inputProps={{ 'aria-label': 'controlled' }} /> }/>
                            {this.state.ingresoFuncionario.conFormacion
                            ?
                                <Box sx={{ flexGrow: 1}}>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2.1}>
                                            Título Universitario
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='tituloUniversitario1' value={this.state.ingresoFuncionario.tituloUniversitario1} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Fecha De Expedido
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoTitulo1' value={this.state.ingresoFuncionario.fechaExpedidoTitulo1} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Maestría
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='maestria1' value={this.state.ingresoFuncionario.maestria1} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Fecha De Expedido
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidaMaestria1' value={this.state.ingresoFuncionario.fechaExpedidaMaestria1} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Postgrado
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='postgrado1' value={this.state.ingresoFuncionario.postgrado1} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Fecha De Expedido
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoPostgrado1' value={this.state.ingresoFuncionario.fechaExpedidoPostgrado1} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Título Universitario
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='tituloUniversitario2' value={this.state.ingresoFuncionario.tituloUniversitario2} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            FECHA DE EXPEDIDO
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoTitulo2' value={this.state.ingresoFuncionario.fechaExpedidoTitulo2} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Maestría
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='maestria2' value={this.state.ingresoFuncionario.maestria2} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            FECHA DE EXPEDIDO
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidaMaestria2' value={this.state.ingresoFuncionario.fechaExpedidaMaestria2} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Postgrado
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='postgrado2' value={this.state.ingresoFuncionario.postgrado2} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            FECHA DE EXPEDIDO
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoPostgrado2' value={this.state.ingresoFuncionario.fechaExpedidoPostgrado2} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Título Universitario
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='tituloUniversitario3' value={this.state.ingresoFuncionario.tituloUniversitario3} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            FECHA DE EXPEDIDO
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoTitulo3' value={this.state.ingresoFuncionario.fechaExpedidoTitulo3} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Maestría
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='maestria3' value={this.state.ingresoFuncionario.maestria3} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            FECHA DE EXPEDIDO
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidaMaestria3' value={this.state.ingresoFuncionario.fechaExpedidaMaestria3} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            Postgrado
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='postgrado3' value={this.state.ingresoFuncionario.postgrado3} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            FECHA DE EXPEDIDO
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='postgrado3' value={this.state.ingresoFuncionario.postgrado3} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                    </Grid>
                                </Box>
                            :
                                null
                            }
                        </fieldset>
                    :
                        null
                    }
                    {this.state.realizoConsulta
                    ?
                        <fieldset>
                            <legend>DATOS FUNCIONARIOS</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.14}>
                                        Código Relación Laboral <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {this.state.modificar
                                    ?
                                        <Grid item xs={3}>
                                            {this.state.codRelaLaboral.map((name) => {
                                                if(name.idCodigoRelacionLaboral === this.state.ingresoFuncionario.codigoRelacionLaboral){
                                                    codRelLab = name.descripcion;
                                                }
                                            })}
                                            {codRelLab}
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoRelacionLaboral' value={this.state.ingresoFuncionario.codigoRelacionLaboral} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>CODIGO RELACION LABORAL</option>
                                                {this.state.codRelaLaboral.map((name) =>
                                                <option
                                                key={name.idCodigoRelacionLaboral}
                                                value={name.idCodigoRelacionLaboral}
                                                >{name.descripcion}</option>
                                                )}
                                            </select>
                                        </Grid>
                                    }
                                    <Grid item xs={2.1}>
                                        Código Forma De Pago <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {this.state.modificar
                                    ?
                                        <Grid item xs={3}>
                                            {this.state.codFormaPago.map((name) => {
                                                if(name.idCodigoFormaPago === this.state.ingresoFuncionario.codigoFormaPago){
                                                    codForPago = name.descripcion;
                                                }
                                            })}
                                            {codForPago}
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoFormaPago' value={this.state.ingresoFuncionario.codigoFormaPago} onChange={this.manejarCambiosDatos}>
                                            <option value={''}>CODIGO FORMA DE PAGO</option>
                                                {this.state.codFormaPago.map((name) =>
                                                <option
                                                key={name.idCodigoFormaPago}
                                                value={name.idCodigoFormaPago}
                                                >{name.descripcion}</option>
                                                )}
                                                </select>
                                        </Grid>
                                    }
                                    <Grid item xs={2.1}>
                                        Cargo <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {this.state.modificar
                                    ?
                                        <Grid item xs={3}>
                                            {this.state.cargos.map((name) => {
                                                if(name.idCargo === this.state.ingresoFuncionario.cargo){
                                                    cargo = name.descripcion;
                                                }
                                            })}
                                            {cargo}
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={this.state.ingresoFuncionario.cargo} onChange={this.manejarCambiosDatos}>
                                                <option value=''>CARGOS</option>
                                                {this.state.cargos.map((name) =>
                                                    <option
                                                    key={name.idCargo}
                                                    value={name.idCargo}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                    }
                                    {/*<Grid item xs={3}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={this.state.ingresoFuncionario.cargo} onChange={this.manejarCambiosDatos}>
                                            <option value=''>CARGOS</option>
                                            {this.state.cargos.map((name) =>
                                                <option
                                                key={name.idCargo}
                                                value={name.idCargo}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>*/}
                                    <Grid item xs={2.1}>
                                        Escalafón <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {this.state.modificar
                                    ?
                                        <Grid item xs={3}>
                                            {this.state.escalafones.map((name) => {
                                                if(name.idEscalafon === this.state.ingresoFuncionario.escalafon){
                                                    escalafon = name.descripcion;
                                                }
                                            })}
                                            {escalafon}
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.ingresoFuncionario.escalafon} onChange={this.manejarCambiosDatos}>
                                                <option value=''>ESCALAFON</option>
                                                {this.state.escalafones.map((name) =>
                                                    <option
                                                    key={name.idEscalafon}
                                                    value={name.idEscalafon}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                    }
                                    {/*<Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.ingresoFuncionario.escalafon} onChange={this.manejarCambiosDatos}>
                                                <option value=''>ESCALAFON</option>
                                                {this.state.escalafones.map((name) =>
                                                    <option
                                                    key={name.idEscalafon}
                                                    value={name.idEscalafon}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                    </Grid>*/}
                                    <Grid item xs={2.1}>
                                        Grado <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {this.state.modificar
                                    ?
                                        <Grid item xs={3}>
                                            {this.state.ingresoFuncionario.grado}
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado' value={this.state.ingresoFuncionario.grado} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>GRADO</option>
                                                <option value={1}>1</option>
                                                <option value={2}>2</option>
                                                <option value={3}>3</option>
                                                <option value={4}>4</option>
                                                <option value={5}>5</option>
                                                <option value={6}>6</option>
                                                <option value={7}>7</option>
                                                <option value={8}>8</option>
                                                <option value={9}>9</option>
                                                <option value={10}>10</option>
                                                <option value={11}>11</option>
                                                <option value={12}>12</option>
                                                <option value={13}>13</option>
                                                <option value={14}>14</option>
                                                <option value={15}>15</option>
                                                <option value={16}>16</option>
                                                </select>
                                        </Grid>
                                    }
                                    {/*<Grid item xs={3}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado' value={this.state.ingresoFuncionario.grado} onChange={this.manejarCambiosDatos}>
                                            <option value={''}>GRADO</option>
                                            <option value={1}>1</option>
                                            <option value={2}>2</option>
                                            <option value={3}>3</option>
                                            <option value={4}>4</option>
                                            <option value={5}>5</option>
                                            <option value={6}>6</option>
                                            <option value={7}>7</option>
                                            <option value={8}>8</option>
                                            <option value={9}>9</option>
                                            <option value={10}>10</option>
                                            <option value={11}>11</option>
                                            <option value={12}>12</option>
                                            <option value={13}>13</option>
                                            <option value={14}>14</option>
                                            <option value={15}>15</option>
                                            <option value={16}>16</option>
                                            </select>
                                    </Grid>*/}
                                    <Grid item xs={2.1}>
                                        Serie Concurso<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {this.state.modificar
                                    ?
                                        <Grid item xs={3}>
                                            {this.state.serieBase.map((name) => {
                                                if(name.idSerie === this.state.ingresoFuncionario.serie){
                                                    serieConcurso = name.descripcion;
                                                }
                                            })}
                                            {serieConcurso}
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='serie' value={this.state.ingresoFuncionario.serie} onChange={this.manejarCambiosDatos} >
                                                <option value={''}>SERIE CONCURSO</option>
                                                {this.state.serieBase.map((name) =>
                                                    <option
                                                    key={name.idSerie}
                                                    value={name.idSerie}
                                                    >{name.descripcion}</option>
                                                )}
                                            </select>
                                        </Grid>
                                    }
                                    <Grid item xs={2.1}>
                                        Carga Horaria <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {this.state.modificar
                                    ?
                                        <Grid item xs={3}>
                                            {this.state.ingresoFuncionario.cargaHorariaHoras}
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                            <input style={{width:"50%", border:"2px solid #D6EAF8", float:"left"}} type="number" id='cargaHorariaHoras' placeholder='HORAS' value={this.state.ingresoFuncionario.cargaHorariaHoras} onChange={this.manejarCambiosDatos}/>
                                            <input style={{width:"50%", border:"2px solid #D6EAF8"}} type="number" placeholder='MINUTOS' id='cargaHorariaMinutos' value={this.state.ingresoFuncionario.cargaHorariaMinutos} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                    }
                                    {/*<Grid item xs={3}>
                                        <input style={{width:"50%", border:"2px solid #D6EAF8", float:"left"}} type="number" id='cargaHorariaHoras' placeholder='HORAS' value={this.state.ingresoFuncionario.cargaHorariaHoras} onChange={this.manejarCambiosDatos}/>
                                        <input style={{width:"50%", border:"2px solid #D6EAF8"}} type="number" placeholder='MINUTOS' id='cargaHorariaMinutos' value={this.state.ingresoFuncionario.cargaHorariaMinutos} onChange={this.manejarCambiosDatos}/>
                                    </Grid>*/}
                                    <Grid item xs={2.1}>
                                        Horario <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {/*<Item><input style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} type="text" id='horaEntrada' placeholder='ENTRADA' value={this.state.ingresoFuncionario.horaEntrada} onChange={this.manejarCambiosDatos}/>
                                            <input style={{width:"50%", border:"2px solid #D6EAF8"}} type="text" id='horarioSalida' placeholder='SALIDA' value={this.state.ingresoFuncionario.horarioSalida} onChange={this.manejarCambiosDatos}/></Item>*/}
                                            <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='horaEntrada' value={this.state.ingresoFuncionario.horaEntrada} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>ENTRADA</option>
                                                    {this.state.horasEntrada.map((name) =>
                                                    <option
                                                    key={name.idEntrada}
                                                    value={name.idEntrada}
                                                    >{name.descripcion}
                                                </option>
                                                )}
                                            </select>
                                            <select style={{width:"50%", border:"2px solid #D6EAF8"}} id='horarioSalida' value={this.state.ingresoFuncionario.horarioSalida} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>SALIDA</option>
                                                    {this.state.horasSalida.map((name) =>
                                                    <option
                                                    key={name.idSalida}
                                                    value={name.idSalida}
                                                    >{name.descripcion}
                                                </option>
                                                )}
                                            </select>
                                    </Grid>
                                    {/*<Grid item xs={2.1}>
                                        <Item>Hora De Entrada <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='horaEntrada' value={this.state.ingresoFuncionario.horaEntrada} onChange={this.manejarCambiosDatos}/></Item>
                                    </Grid>*/}
                                    <Grid item xs={2.1}>
                                        Lugar <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    {this.state.modificar
                                    ?
                                        <Grid item xs={3}>
                                            {this.state.lugaresTrabajo.map((name) => {
                                                if(name.idLugaresTrabajo === this.state.ingresoFuncionario.lugar){
                                                    desc = name.lugar;
                                                }
                                            })}
                                            {desc}
                                        </Grid>
                                    :
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugar" value={this.state.ingresoFuncionario.lugar} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>LUGAR</option>
                                                {this.state.lugaresTrabajo.map((name) =>
                                                    <option
                                                    key={name.idLugaresTrabajo}
                                                    value={name.idLugaresTrabajo}
                                                    >{name.lugar}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                    }
                                    {/*<Grid item xs={3}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugar" value={this.state.ingresoFuncionario.lugar} onChange={this.manejarCambiosDatos}>
                                            <option value={''}>LUGAR</option>
                                            {this.state.lugaresTrabajo.map((name) =>
                                                <option
                                                key={name.idLugaresTrabajo}
                                                value={name.idLugaresTrabajo}
                                                >{name.lugar}</option>
                                                )}
                                        </select>
                                    </Grid>*/}
                                    {this.state.ingresoFuncionario.lugar == '0' ?
                                        <Grid item xs={2.1} >
                                            Lugar CENTRAL<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.ingresoFuncionario.lugar == '0'
                                    ?
                                        this.state.modificar
                                        ?
                                            <Grid item xs={3}>
                                                {this.state.ubicacionesCentral.map((name) => {
                                                    if(name.idUbicacionesCentral === this.state.ingresoFuncionario.lugarCentral){
                                                        lugarCentral = name.descripcion;
                                                    }
                                                })}
                                                {lugarCentral}
                                            </Grid>
                                        :
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugarCentral" value={this.state.ingresoFuncionario.lugarCentral} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>LUGAR CENTRAL</option>
                                                    {this.state.ubicacionesCentral.map((name) =>
                                                        <option
                                                        key={name.idUbicacionesCentral}
                                                        value={name.idUbicacionesCentral}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                            </Grid>
                                    :
                                        null
                                    }
                                    {/*this.state.ingresoFuncionario.lugar == '0' ?
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugarCentral" value={this.state.ingresoFuncionario.lugarCentral} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>LUGAR CENTRAL</option>
                                                {this.state.ubicacionesCentral.map((name) =>
                                                    <option
                                                    key={name.idUbicacionesCentral}
                                                    value={name.idUbicacionesCentral}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                    :
                                        null
                                    */}
                                    <Grid item xs={2.1}>
                                        Sueldo Base <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='sueldoBase' placeholder='SUELDO BASE' value={this.state.ingresoFuncionario.sueldoBase} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Regimen Medicos Interior<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='regimenMedicos' value={this.state.ingresoFuncionario.regimenMedicos} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>REGIMEN</option>
                                                <option value={0}>NO</option>
                                                <option value={1}>SI</option>
                                            </select>
                                    </Grid>
                                    {/*<Grid item xs={2.1}>
                                        <Item>Subrogación <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='subroga' value={this.state.ingresoFuncionario.subroga} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>SUBROGACION</option>
                                                <option value={0}>NO</option>
                                                <option value={1}>SI</option>
                                            </select>
                                        </Item>
                                    </Grid>*/}
                                    {/*this.state.ingresoFuncionario.subroga === '1'
                                    ?
                                        <Grid item xs={2.1}>
                                            <Item>Grado Subrogación <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                        </Grid>
                                    :
                                        null
                                    */}
                                    {/*this.state.ingresoFuncionario.subroga === '1'
                                    ?
                                        <Grid item xs={3}>
                                            <Item>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='gradoSubrogacion' value={this.state.ingresoFuncionario.gradoSubrogacion} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>GRADO SUBROGACION</option>
                                                    <option value={1}>1</option>
                                                    <option value={2}>2</option>
                                                    <option value={3}>3</option>
                                                    <option value={4}>4</option>
                                                    <option value={5}>5</option>
                                                    <option value={6}>6</option>
                                                    <option value={7}>7</option>
                                                    <option value={8}>8</option>
                                                    <option value={9}>9</option>
                                                    <option value={10}>10</option>
                                                    <option value={11}>11</option>
                                                    <option value={12}>12</option>
                                                    <option value={13}>13</option>
                                                    <option value={14}>14</option>
                                                    <option value={15}>15</option>
                                                    <option value={16}>16</option>
                                                </select>
                                            </Item>
                                        </Grid>
                                    :
                                        null
                                    */}
                                    {/*this.state.ingresoFuncionario.subroga === '1'
                                    ?
                                        <Grid item xs={2.1}>
                                            <Item>Escalafón Subrogación <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                        </Grid>
                                    :
                                        null
                                    */}
                                    {/*this.state.ingresoFuncionario.subroga === '1'
                                    ?
                                        <Grid item xs={3}>
                                            <Item>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafonSubrogacion'  value={this.state.ingresoFuncionario.escalafonSubrogacion} onChange={this.manejarCambiosDatos}>
                                                    <option value=''>ESCALAFON SUBROGACION</option>
                                                    {this.state.escalafones.map((name) =>
                                                        <option
                                                        key={name.idEscalafon}
                                                        value={name.idEscalafon}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                            </Item>
                                        </Grid>
                                    :
                                        null
                                    */}
                                    {/*this.state.ingresoFuncionario.subroga === '1'
                                    ?
                                        <Grid item xs={2.1}>
                                            <Item>Carga Horaria Subrogación <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                        </Grid>
                                    :
                                        null
                                    */}
                                    {/*this.state.ingresoFuncionario.subroga === '1'
                                    ?
                                        <Grid item xs={3}>
                                            <Item><input style={{width:"50%", border:"2px solid #D6EAF8", float:"left"}} type="number" id='cargaHorariaHoraSubrogacioncargaHorariaHoraSubrogacion' placeholder='HORAS' value={this.state.ingresoFuncionario.cargaHorariaHoraSubrogacion} onChange={this.manejarCambiosDatos}/>
                                            <input style={{width:"50%", border:"2px solid #D6EAF8"}} type="number" placeholder='MINUTOS' id='cargaHorariaMinutosSubrogacion' value={this.state.ingresoFuncionario.cargaHorariaMinutosSubrogacion} onChange={this.manejarCambiosDatos}/>
                                            </Item>
                                        </Grid>
                                    :
                                        null
                                    */}
                                    {/*this.state.ingresoFuncionario.subroga === '1'
                                    ?
                                        <Grid item xs={2.1}>
                                            <Item>Desde Subrogación <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                        </Grid>
                                    :
                                        null
                                    */}
                                    {/*this.state.ingresoFuncionario.subroga === '1'
                                    ?
                                        <Grid item xs={3}>
                                            <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='desdeSubrogacion' value={this.state.ingresoFuncionario.desdeSubrogacion} onChange={this.manejarCambiosDatos}/></Item>
                                        </Grid>
                                    :
                                        null
                                    */}
                                </Grid>
                            </Box>
                        </fieldset>
                    :
                        null
                    }
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.realizoConsulta
                    ?
                        <Box>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={3}>
                                    <button className="btn btn-outline-primary" type='submit'> {this.state.modificar ? 'Modificar' : 'Confirmar'}</button>
                                </Grid>
                                <Grid item xs={3} >
                                    {this.state.modificar ? this.state.baja ? <button type="button" className="btn btn-outline-primary" onClick={this.darDeBaja}> Dar de Baja</button> : <button type="button" className="btn btn-outline-primary" onClick={this.activarFuncionario}> Activar Funcionario</button> : null}
                                </Grid>
                            </Grid>
                        </Box>
                    :
                        null
                    }
                </form>
            </div>
        )//Final del return
    }//Final render


    async manejarEnvioFormulario(e){
        e.preventDefault();
        if(this.state.ingresoFuncionario.numeroFuncionario === '' || this.state.ingresoFuncionario.pNombre === '' || this.state.ingresoFuncionario.pApellido === '' || this.state.ingresoFuncionario.ci === ''){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else if(this.state.ingresoFuncionario.fechNacimiento === '' || this.state.ingresoFuncionario.credencialSerie === '' || this.state.ingresoFuncionario.credencialNumero === ''){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else if(this.state.ingresoFuncionario.direccionCalle === '' || this.state.ingresoFuncionario.direccionNumero === '' || this.state.ingresoFuncionario.direccionLocalidad === '' || this.state.ingresoFuncionario.direccionDepartamento === ''){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else if(this.state.ingresoFuncionario.sexo === '' || this.state.ingresoFuncionario.codigoRelacionLaboral === '' || this.state.ingresoFuncionario.codigoFormaPago === '' || this.state.ingresoFuncionario.codigoIngreso === ''){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else if(this.state.ingresoFuncionario.cargo === '' || this.state.ingresoFuncionario.escalafon === '' || this.state.ingresoFuncionario.grado === '' || this.state.ingresoFuncionario.serie === ''){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else if(this.state.ingresoFuncionario.cargaHorariaHoras === '' || this.state.ingresoFuncionario.cargaHorariaMinutos === '' || this.state.ingresoFuncionario.horarioSalida === ''){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else if(this.state.ingresoFuncionario.horaEntrada === '' || this.state.ingresoFuncionario.lugar === '' || this.state.ingresoFuncionario.vinculacion === ''){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else if(this.state.ingresoFuncionario.celular === '' || this.state.ingresoFuncionario.carneSalud === '' || this.state.ingresoFuncionario.ingresoInstitucion === '' || this.state.ingresoFuncionario.sueldoBase === '' || this.state.ingresoFuncionario.regimenMedicos === ''){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else if((["0", "1", "2", "3", "4", "5"].includes(String(this.state.ingresoFuncionario.codigoIngreso))) && (this.state.ingresoFuncionario.puntajeConcurso === '' || this.state.ingresoFuncionario.lugarOrdenamiento === '')){
            this.setState({
                errores: 'LOS CAMPOS MARCADOS CON * SON OBLIGATORIOS',
            });
        }else{

            //Codifico el estado interno de lo que voy a enviar
            const cargaUtil = JSON.stringify([this.state.ingresoFuncionario, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_funcionario.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito,
            });

            if((exito === 'ok') || (this.state.ingresoFuncionario.modificarUsu)){
                this.setState({
                    notificaciones: 'LOS DATOS FUERON INGRESADOS CORRECTAMENTE',
                    errores: null,
                    datosObtenidos: {
                        primerNombre: '',
                        segundoNombre: '',
                        primerApellido: '',
                        segundoApellido: '',
                        ci: '',
                        fechaNacimiento: '',
                        credencialSerie: '',
                        credencialNumero: '',
                        direccionCalle: '',
                        direccionNumero: '',
                        direccionLocalidad: '',
                        direccionDepartamento: '',
                        telefono: '',
                        celular: '',
                        carneSalud: '',
                        sexo: '',
                        id: '',
                        antiguedad: '0',
                        vinculacion: '',
                        //
                        ingresoInstitucion: '',
                        tituloUniversitario1: '',
                        fechaTitulo1: '',
                        maestria1: '',
                        fechaMaestria1: '',
                        postgrado1: '',
                        fechaPostgrado1: '',
                        tituloUniversitario2: '',
                        fechaTitulo2: '',
                        maestria2: '',
                        fechaMaestria2: '',
                        postgrado2: '',
                        fechaPostgrado2: '',
                        tituloUniversitario3: '',
                        fechaTitulo3: '',
                        maestria3: '',
                        fechaMaestria3: '',
                        postgrado3: '',
                        fechaPostgrado3: '',
                        cargo: '',
                        escalafon: '',
                        grado: '',
                        serieConcurso: '',
                        cargaHorariaHora: '',
                        cargaHorariaMinuto: '',
                        horarioSalida: '',
                        horaEntrada: '',
                        lugar: '',
                        lugarCentral: '',
                        diasLicencia: '0',
                        codigoRelLaboral: '',
                        codigoForPago: '',
                        idUsuario: '',
                        idFuncionario: '',
                        idForAcademica: '',
                        activo: '1',
                        sueldoBase: '',
                        subroga: '',
                        gradoSubrogacion: '',
                        escalafonSubrogacion: '',
                        cargaHorariaHoraSubrogacion: '',
                        cargaHorariaMinutosSubrogacion: '',
                        desdeSubrogacion: '',
                        conFormacion: false,
                        regimenMedicos: '',
                    },
                });
                this.actualizarDatos();

            }else{
                if((this.state.ingresoFuncionario.modificarUsu)){
                    this.setState({
                        errores: 'LOS DATOS NO FUERON MODIFICADOS',
                    })
                }
                this.setState({
                    notificaciones: null,
                });
            }
        }
    }


    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(!this.state.ingresoFuncionario.numeroFuncionario.trim()){
            this.setState({
                errores: "DEBE INGRESAR UN NUMERO DE FUNCIONARIO!",
            });
        }else{
            this.setState({
                errores: null,
                realizoConsulta: true,
            })
            const cargaUtil = JSON.stringify(this.state.ingresoFuncionario);
            const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_NumFun.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                notificaciones: null,
            });
            if(exito){
                if(exito.length === 0){
                    this.setState({
                        errores: 'NO EXISTEN DATOS PARA EL NUMERO DE FUNCIONARIO INGRESADO',
                        datosObtenidos: {
                            primerNombre: '',
                            segundoNombre: '',
                            primerApellido: '',
                            segundoApellido: '',
                            ci: '',
                            fechaNacimiento: '',
                            credencialSerie: '',
                            credencialNumero: '',
                            direccionCalle: '',
                            direccionNumero: '',
                            direccionLocalidad: '',
                            direccionDepartamento: '',
                            telefono: '',
                            celular: '',
                            carneSalud: '',
                            sexo: '',
                            id: '',
                            antiguedad: '0',
                            vinculacion: '',
                            //
                            ingresoInstitucion: '',
                            tituloUniversitario1: '',
                            fechaTitulo1: '',
                            maestria1: '',
                            fechaMaestria1: '',
                            postgrado1: '',
                            fechaPostgrado1: '',
                            tituloUniversitario2: '',
                            fechaTitulo2: '',
                            maestria2: '',
                            fechaMaestria2: '',
                            postgrado2: '',
                            fechaPostgrado2: '',
                            tituloUniversitario3: '',
                            fechaTitulo3: '',
                            maestria3: '',
                            fechaMaestria3: '',
                            postgrado3: '',
                            fechaPostgrado3: '',
                            cargo: '',
                            escalafon: '',
                            grado: '',
                            serieConcurso: '',
                            cargaHorariaHora: '',
                            cargaHorariaMinuto: '',
                            horarioSalida: '',
                            horaEntrada: '',
                            lugar: '',
                            lugarCentral: '',
                            diasLicencia: '0',
                            codigoRelLaboral: '',
                            codigoForPago: '',
                            idUsuario: '',
                            idFuncionario: '',
                            idForAcademica: '',
                            activo: '1',
                            sueldoBase: '',
                            subroga: '',
                            gradoSubrogacion: '',
                            escalafonSubrogacion: '',
                            cargaHorariaHoraSubrogacion: '',
                            cargaHorariaMinutosSubrogacion: '',
                            desdeSubrogacion: '',
                            regimenMedicos: '',
                            codigoIngreso: '',
                            puntajeConcurso: '',
                            lugarOrdenamiento: '',
                        },
                        modificar: false,
                        baja: false,
                    });
                    this.setState(state => {
                        const funcionarioActualizado = state.ingresoFuncionario;
                        funcionarioActualizado['modificarUsu'] = false;
                        return{
                            ingresoFuncionario: funcionarioActualizado,
                        }
                    });
                }else{
                    this.setState({
                        datosObtenidos: exito[0],
                        modificar: true,
                    });
                    if(exito[0].activo === 1){
                        this.setState({
                            baja: true,
                        })
                    }
                    this.setState(state => {
                        const funcionarioActualizado = state.ingresoFuncionario;
                        funcionarioActualizado['modificarUsu'] = true;
                        return{
                            ingresoFuncionario: funcionarioActualizado,
                        }
                    });
                }
                this.actualizarDatos();
            }
        }
    }

    actualizarDatos(e){
        this.setState(state => {
            const funcionarioActualizado = state.ingresoFuncionario;
            funcionarioActualizado['pNombre'] = state.datosObtenidos.primerNombre;
            funcionarioActualizado['sNombre'] = state.datosObtenidos.segundoNombre;
            funcionarioActualizado['pApellido'] = state.datosObtenidos.primerApellido;
            funcionarioActualizado['sApellido'] = state.datosObtenidos.segundoApellido;
            funcionarioActualizado['ci'] = state.datosObtenidos.ci;
            funcionarioActualizado['fechNacimiento'] = state.datosObtenidos.fechaNacimiento;
            funcionarioActualizado['credencialSerie'] = state.datosObtenidos.credencialSerie;
            funcionarioActualizado['credencialNumero'] = state.datosObtenidos.credencialNumero;
            funcionarioActualizado['direccionCalle'] = state.datosObtenidos.direccionCalle;
            funcionarioActualizado['direccionNumero'] = state.datosObtenidos.direccionNumero;
            funcionarioActualizado['direccionLocalidad'] = state.datosObtenidos.direccionLocalidad;
            funcionarioActualizado['direccionDepartamento'] = state.datosObtenidos.direccionDepartamento;
            funcionarioActualizado['telefono'] = state.datosObtenidos.telefono;
            funcionarioActualizado['celular'] = state.datosObtenidos.celular;
            funcionarioActualizado['carneSalud'] = state.datosObtenidos.carneSalud;
            funcionarioActualizado['sexo'] = state.datosObtenidos.sexo;
            funcionarioActualizado['idUsuario'] = state.datosObtenidos.idUsuario;
            funcionarioActualizado['antiguedad'] = state.datosObtenidos.antiguedad;
            funcionarioActualizado['vinculacion'] = state.datosObtenidos.vinculacion;
            //De aca para abajo tengo que agregarlo en los otros lados
            funcionarioActualizado['ingresoInstitucion'] = state.datosObtenidos.ingresoInstitucion;
            funcionarioActualizado['tituloUniversitario1'] = state.datosObtenidos.tituloUniversitario1;
            funcionarioActualizado['fechaExpedidoTitulo1'] = state.datosObtenidos.fechaTitulo1;
            funcionarioActualizado['maestria1'] = state.datosObtenidos.maestria1;
            funcionarioActualizado['fechaExpedidaMaestria1'] = state.datosObtenidos.fechaMaestria1;
            funcionarioActualizado['postgrado1'] = state.datosObtenidos.postgrado1;
            funcionarioActualizado['fechaExpedidoPostgrado1'] = state.datosObtenidos.fechaPostgrado1;
            funcionarioActualizado['tituloUniversitario2'] = state.datosObtenidos.tituloUniversitario2;
            funcionarioActualizado['fechaExpedidoTitulo2'] = state.datosObtenidos.fechaTitulo2;
            funcionarioActualizado['maestria2'] = state.datosObtenidos.maestria2;
            funcionarioActualizado['fechaExpedidaMaestria2'] = state.datosObtenidos.fechaMaestria2;
            funcionarioActualizado['postgrado2'] = state.datosObtenidos.postgrado2;
            funcionarioActualizado['fechaExpedidoPostgrado2'] = state.datosObtenidos.fechaPostgrado2;
            funcionarioActualizado['tituloUniversitario3'] = state.datosObtenidos.tituloUniversitario3;
            funcionarioActualizado['fechaExpedidoTitulo3'] = state.datosObtenidos.fechaTitulo3;
            funcionarioActualizado['maestria3'] = state.datosObtenidos.maestria3;
            funcionarioActualizado['fechaExpedidaMaestria3'] = state.datosObtenidos.fechaMaestria3;
            funcionarioActualizado['postgrado3'] = state.datosObtenidos.postgrado3;
            funcionarioActualizado['fechaExpedidoPostgrado3'] = state.datosObtenidos.fechaPostgrado3;
            funcionarioActualizado['cargo'] = state.datosObtenidos.cargo;
            funcionarioActualizado['escalafon'] = state.datosObtenidos.escalafon;
            funcionarioActualizado['grado'] = state.datosObtenidos.grado;
            funcionarioActualizado['serie'] = state.datosObtenidos.serieConcurso;
            funcionarioActualizado['cargaHorariaHoras'] = state.datosObtenidos.cargaHorariaHora;
            funcionarioActualizado['cargaHorariaMinutos'] = state.datosObtenidos.cargaHorariaMinuto;
            funcionarioActualizado['horarioSalida'] = state.datosObtenidos.horarioSalida;
            funcionarioActualizado['horaEntrada'] = state.datosObtenidos.horaEntrada;
            funcionarioActualizado['lugar'] = state.datosObtenidos.lugar;
            funcionarioActualizado['lugarCentral'] = state.datosObtenidos.lugarCentral;
            funcionarioActualizado['diasLicencia'] = state.datosObtenidos.diasLicencia;
            funcionarioActualizado['codigoRelacionLaboral'] = state.datosObtenidos.codigoRelLaboral;
            funcionarioActualizado['codigoIngreso'] = state.datosObtenidos.codigoIngreso !== null ? state.datosObtenidos.codigoIngreso : '';
            funcionarioActualizado['puntajeConcurso'] = state.datosObtenidos.puntajeConcurso !== null ? state.datosObtenidos.puntajeConcurso : '';
            funcionarioActualizado['lugarOrdenamiento'] = state.datosObtenidos.lugarOrdenamiento !== null ? state.datosObtenidos.lugarOrdenamiento : '';
            funcionarioActualizado['codigoFormaPago'] = state.datosObtenidos.codigoForPago;
            funcionarioActualizado['idFuncionario'] = state.datosObtenidos.idFuncionario;
            funcionarioActualizado['idForAcademica'] = state.datosObtenidos.idForAcademica;
            funcionarioActualizado['activo'] = state.datosObtenidos.activo;
            funcionarioActualizado['sueldoBase'] = state.datosObtenidos.sueldoBase;
            funcionarioActualizado['subroga'] = state.datosObtenidos.subroga;
            funcionarioActualizado['regimenMedicos'] = state.datosObtenidos.regimenMedicos;
            if(state.datosObtenidos.subroga === '1'){
                funcionarioActualizado['gradoSubrogacion'] = state.datosObtenidos.gradoSubrogacion;
            }else{
                funcionarioActualizado['gradoSubrogacion'] = '';
            }

            if(state.datosObtenidos.tituloUniversitario1 !== ''){
                funcionarioActualizado['conFormacion'] = true;
            }
            
            return{
                ingresoFuncionario: funcionarioActualizado,
            }
        });
    }


    async activarFuncionario(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        });
        const cargaUtil = JSON.stringify([this.state.ingresoFuncionario.ci, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado, this.state.ingresoFuncionario.numeroFuncionario]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/activar_funcionario.php`,{
            method: 'POST',
            body: cargaUtil,
        });
        const exito = await respuesta.json();
        if(exito){
            this.setState({
                notificaciones: 'EL FUNCIONARIO FUE ACTIVADO CORRECTAMENTE',
            });
            this.setState(state => {
                const funcionarioActualizado = state.ingresoFuncionario;
                funcionarioActualizado['activo'] = '1';
                return{
                    ingresoFuncionario: funcionarioActualizado,
                };
            })
        }
    }
    async darDeBaja(e){
        //Tengo que ponerlo inactivo
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        });
        const cargaUtil = JSON.stringify([this.state.ingresoFuncionario.ci, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado, this.state.ingresoFuncionario.numeroFuncionario]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/baja_usuario.php`,{
            method: 'POST',
            body: cargaUtil,
        });
        const exito = await respuesta.json();
        if(exito){
            this.setState({
                notificaciones: 'EL FUNCIONARIO FUE DADO DE BAJA CORRECTAMENTE',
            });
        }

    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.ingresoFuncionario;
            if(clave === "pNombre" || clave === "sNombre" || clave === "pApellido" || clave === "sApellido" || clave === 'credencialSerie' || clave === "escalafon"){
                valor = valor.toUpperCase();
            }
            if((clave === 'puntajeConcurso')){
                if ((parseInt(valor, 10) < 0) || (parseInt(valor, 10) > 100)) {
                    alert('El puntaje debe ser entre 1 y 100.');
                    valor = '';
                    //return;
                }
            }
            if((clave === 'lugarOrdenamiento')){
                if ((parseInt(valor, 10) < 0) || (parseInt(valor, 10) > 100)) {
                    alert('El lugar de ordenamiento debe ser entre 1 y 100.');
                    valor = '';
                    //return;
                }
            }
            funcionarioActualizado[clave] = valor;
            return{
                ingresoFuncionario: funcionarioActualizado,
            };
        })
    }

    manejarCambiosDatosFormacion(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const funcionarioActualizado = state.ingresoFuncionario;
            funcionarioActualizado[clave] = valor;
            return{
                ingresoFuncionario: funcionarioActualizado,
            };
        })
    }
}
export default IngresoFuncionarios;